'use client'

import { useDeviceType } from 'hooks/useDeviceType'
import CTAHandLeft from 'public/assets/cta-hand-left.svg'
import CTAHandRight from 'public/assets/cta-hand-right.svg'
import CTAButton from '../Buttons/CTAButton/CTAButton'
import styles from './CTA.module.scss'

type Props = {
  inGrid?: boolean
}

const CTA = ({ inGrid = false }: Props) => {
  const { isMobile } = useDeviceType()

  return (
    <section className={styles.CTA + (inGrid ? ' ' + styles['in-grid'] : '')}>
      {isMobile ? (
        <>
          <div className={styles.row}>
            <CTAHandLeft className={styles.left} />
            <CTAHandRight className={styles.right} />
          </div>
          <div className={styles.content}>
            <div className={styles.text}>
              <span>No buzzwords, just great</span>
              <span>Product Development</span>
            </div>
            <CTAButton text='Get in Touch!' background='dark' />
          </div>
        </>
      ) : (
        <>
          <CTAHandLeft className={styles.left} />
          <div className={styles.content}>
            <div className={styles.text}>
              <span>No buzzwords, just great</span>
              <span>Product Development</span>
            </div>
            <CTAButton text='Get in Touch!' background='dark' />
          </div>
          <CTAHandRight className={styles.right} />
        </>
      )}
    </section>
  )
}

export default CTA
